import React from 'react';
import { IconsPros } from './types';

/**
 * Social Icon component
 *
 * @returns JSX.ELEMENT
 */
export const SocialIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M9.86,11.42c-1.48,0-3.43-.51-3.43-1V7.84c0-.4,1.23-1.12,1.76-1.47,1-.62,1.63-2,1.83-1.74.85,1-.61,2.25-.55,2.38s1.72.13,1.72.64S10.4,11.42,9.86,11.42ZM6,11.21a1.12,1.12,0,0,1-1.19-1.14V8.23A1.15,1.15,0,0,1,6,7c.26,0-.4.22-.4.89v2.41C5.64,11,6.3,11.21,6,11.21ZM13.44,0H2.56A2.5,2.5,0,0,0,0,2.44V13.56A2.5,2.5,0,0,0,2.56,16H13.44A2.5,2.5,0,0,0,16,13.56V2.44A2.51,2.51,0,0,0,13.44,0Z" />
    </svg>
  );
};
